export default "__VITE_ASSET__Buiy$A7z__"